<template>
  <svg width="25" height="50" viewBox="0 0 25 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 24.5614L25 0V50H0V24.5614Z" fill="#00529A"/>
  </svg>
</template>
